import { AppEntities } from "../../../../config/entities";
import React from "react";
import { NewCatalogListView } from "../../../Shared/NewCatalogListView";

const DeviceList = () => {
  const fields = [{ title: "Name", fieldName: "name" }];

  return (
    <>
      <NewCatalogListView fields={fields} entity={AppEntities.Device} />
    </>
  );
};

export default DeviceList;
